import { Store } from 'redux';
import IStore from './store.interface';
import { ShellSDK } from '@walkme/client-shell-sdk';

const generateAuthHeaders = async ({ store, shellSdk }: { store: Store<IStore>; shellSdk?: ShellSDK }) => {
    const systemId = store.getState().common.currentSystem;
    const overrideFeatureFlags = store.getState().common.overrideFeatureFlags;
    let Authorization = '';
    if (shellSdk) {
        const token = (await shellSdk.getToken()) as { access_token: string };
        Authorization = `Bearer ${token.access_token}`;
    }
    return {
        Authorization,
        CommCenterExtraData: JSON.stringify({ systemId, overrideFeatureFlags })
    };
};

export default generateAuthHeaders;
